import React from "react";
import { Helmet } from "react-helmet";

import cloudimg from "../../new_Images/OtherComponents/21.png";
import cloudimg3 from "../images/cloud4.png";
import aws from "../images/aws.png";
import azure from "../images/azure.png";
import gcp from "../images/gcp.jpg";

import "../../App.css";

function CloudServices() {
  return (
    <>
      <Helmet>
        <title>Cloud Services | CLOTA Technology</title>
        <meta
          name="description"
          content="Explore our cloud services including AWS, Azure, GCP, and private cloud management to streamline your business infrastructure."
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Cloud Services | CLOTA Technology" />
        <meta
          property="og:description"
          content="We manage public and private cloud platforms like AWS, Azure, and GCP for optimized performance and security."
        />
                         <meta name="robots" content="index, follow" />
  <meta name="author" content="Clota Technology" />
  <link rel="canonical" href="https://www.clotatech.com/CloudServices" />
      </Helmet>

      {/* <div>
        <img src={cloudimg} className="w-full homebanner" alt="responsiveImage" />
      </div> */}

      <div className="banner-container">
        <img src={cloudimg} className="banner-image" alt="Banner" />

        {/* Centered Content */}
        <div className="banner-content">
          <div className="banner-text">
            <h1 className="banner-heading">Cloud Services</h1>
            <p>
              Discuss best practices for cloud migration, security,
              <br />
              and optimization.
            </p>
          </div>
        </div>
      </div>

      {/* Cloud Services Description */}
      <div className="mt-5 px-5 py-2">
        <div className="grid justify-content-center">
          <div className="col-12">
            <p className="">
              <i>
                Cloud services, hosted by third-party providers and accessed via
                the internet, enable cloud-native applications and flexible
                work. Clota Technology's web development team creates tailored
                websites and applications. Businesses no longer need to purchase
                and manage hardware, reducing costs and complexity.
              </i>
            </p>
          </div>
        </div>
      </div>

      {/* Benefits */}
      <div className="mt-5 px-5 py-2">
        <h4 className="Text-Gradient" style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}>
          <b>
            <i>Benefits of Cloud Services</i>
          </b>
        </h4>
        <p>
          <i>
            Cloud providers create online platforms for code development and app
            running, distinct from abstracting computer capabilities from
            hardware in cloud infrastructure provision.
          </i>
        </p>
      </div>

      {/* Managing Public Clouds */}
      <div className="mt-5 px-5 py-2">
        <div className="grid align-items-center">
          {/* Text Column */}
          <div className="col-12 md:col-6">
            <h4 className="Text-Gradient" style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}>
              <b>
                <i>Managing Public Clouds</i>
              </b>
            </h4>
            <p>
              <i>
                Clota Technology manage major public clouds like Microsoft Azure, Google
                Cloud, and AWS, optimizing and effectively utilizing their
                infrastructure, platforms, and services for our clients.
              </i>
            </p>
          </div>

          {/* Images Column */}
          <div className="col-12 md:col-6">
            <div className="grid justify-content-center">
              {[azure, aws, gcp].map((imgSrc, idx) => (
                <div key={idx} className="col-4 flex justify-content-center">
                  <img
                    src={imgSrc}
                    alt={`cloud-service-${idx}`}
                    style={{ width: "100px", height: "100px" }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.filter = "grayscale(0%)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.filter = "grayscale(100%)")
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Managing Private Cloud */}
      <div className="mt-5 px-5 py-2">
        <div className="grid align-items-center">
          <div className="col-12 md:col-6">
            <h4 className="Text-Gradient" style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}>
              <b>
                <i>Managing Private Cloud</i>
              </b>
            </h4>
            <p>
              <i>
                Managed private cloud providers offer a private cloud that's
                deployed and managed by third parties. Our cloud delivery
                enhances security, cost-effectiveness, storage flexibility,
                automatic updates, quick deployment, and overall efficiency.
              </i>
            </p>
          </div>

          <div className="col-12 md:col-6 flex justify-content-center">
            <img
              src={cloudimg3}
              alt="responsiveImage"
              style={{ width: "300px", height: "270px" }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default CloudServices;
